export default __webpack_public_path__ + "static/media/original.c7d81a5f.png";